document.addEventListener('DOMContentLoaded',()=>{
  const collectionPageProductGrid = document.querySelector('.collection-grid__products');
  if(collectionPageProductGrid) {
    const productCards = collectionPageProductGrid.querySelectorAll('.product-card');
    productCards.forEach(productCard=>{
      const atcButton = productCard.querySelector('quick-add-button');
      if(atcButton) {
        productCard.querySelectorAll('product-card-swatches input[type="radio"]').forEach(variantRadio=>{
          variantRadio.addEventListener('change',()=>{
            const variantId = variantRadio.getAttribute('data-variant-id');
            if(variantId) {
              atcButton.setAttribute('variant-id',variantId);
            }
          });
        });
      }
    });
  }
});